import generateLabel from "./generateLabel";
import _ from "lodash";
import { v4 as uuidv4 } from "uuid";

export const types = {
  open: "open",
  choice: "choice",
  slider: "slider",
  container: "container",
  unknown: "unknown",
};

export const subTypes = {
  open: "open",
  singleChoice: "singleChoice",
  multipleChoice: "multipleChoice",
  yesno: "yesno",
  order: "order",
  likert: "likert",
  slider: "slider",
  smiley: "smiley",
  container: "container",
  multiSmiley: "multiSmiley",
  imageChoice: "imageChoice",
  sliderNeutralPos: "sliderNeutralPos",
  sliderNegPos: "sliderNegPos",
  bodyParts: "bodyParts",
  computation: "computation",
  time: "time",
  count: "count",
  text: "text",
};

export const smileys = {
  happy: "happy",
  angry: "angry",
  sad: "sad",
  surprise: "surprise",
  fear: "fear",
  stress: "stress",
  disgust: "disgust",
  valence: "valence",
};

export function getVisualizationType(type) {
  switch (type) {
    case subTypes.text:
    case subTypes.open:
      return types.open;
    case subTypes.multipleChoice:
    case subTypes.singleChoice:
    case subTypes.likert:
    case subTypes.order:
    case subTypes.yesno:
    case subTypes.multiSmiley:
    case subTypes.bodyParts:
    case subTypes.imageChoice:
      return types.choice;
    case subTypes.smiley:
    case subTypes.slider:
    case subTypes.computation:
    //case subTypes.time:
    case subTypes.sliderNegPos:
    case subTypes.sliderNeutralPos:
      return types.slider;
    case types.container:
      return types.container;

    default:
      return types.unknown;
  }
}

export function getType(type) {
  switch (type) {
    case subTypes.text:
    case subTypes.open:
      return types.open;
    case subTypes.multipleChoice:
    case subTypes.singleChoice:
    case subTypes.likert:
    case subTypes.order:
    case subTypes.yesno:
    case subTypes.computation:
    case subTypes.multiSmiley:
    case subTypes.bodyParts:
    case subTypes.imageChoice:
      return types.choice;
    case subTypes.smiley:
    case subTypes.slider:
    //case subTypes.time:
    case subTypes.sliderNegPos:
    case subTypes.sliderNeutralPos:
      return types.slider;
    case types.container:
      return types.container;
    default:
      return types.unknown;
  }
}

export function isConditionalQuestion(previousQuestionType) {
  switch (getType(previousQuestionType)) {
    case types.choice:
      return true;
    case types.slider:
      return true;
    default:
      return false;
  }
}

export function getDuplicate(question) {
  let newQuestion = _.cloneDeep(question);
  newQuestion.id = uuidv4();
  newQuestion.label = generateLabel(question.label, true);
  return newQuestion;
}

export const initCurate = {
  info: "", // description of title
  title: "",
  allowHide: 1, // disabled checkbox = 1, enabled checkbox = 0
  show: 0, // show the question in the questionlist = 1, hide the question in the question list = 0
  hideTree: 0, // hide descendants = 1, show discendants = 0
  //allowAdd: 0, // add child (conditional) questions = 1, don't add child questions = 0
  fullQuestionEditable: 0,
  minVal: 0, // min value for computation item if fullQuestionEditable = 1
  maxVal: 100, // max value for computation item if fullQuestionEditable = 1
  inputType: "iSlider", //number field (iNumber) or slider field (iSlider) for computation item if fullQuestionEditable = 1
};
